function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7326"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7326"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $89bfd2b346eb71a0$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"9vqfN":"index.81a002e7.js","dBZRy":"bus.2b8d9421.svg","9aJvs":"sbahn.7af6e52f.svg","eZ0Tk":"ubahn.e8b12bc7.svg","ka4z9":"tram.d6ab74b8.png","lkaBR":"regional.4b0fe7d2.png","3ahye":"express.1ef2192f.png","79HrA":"index.5877b5ed.css"}'));




var $338376e393e3617c$exports = {};

$338376e393e3617c$exports = new URL((parcelRequire("27Lyk")).resolve("dBZRy"), import.meta.url).toString();


var $452c02b697ee67fe$exports = {};

$452c02b697ee67fe$exports = new URL((parcelRequire("27Lyk")).resolve("9aJvs"), import.meta.url).toString();


var $9d7edfc41c7a1748$exports = {};

$9d7edfc41c7a1748$exports = new URL((parcelRequire("27Lyk")).resolve("eZ0Tk"), import.meta.url).toString();


var $b5641bcb4042e111$exports = {};

$b5641bcb4042e111$exports = new URL((parcelRequire("27Lyk")).resolve("ka4z9"), import.meta.url).toString();


var $7b76604380f80eba$exports = {};

$7b76604380f80eba$exports = new URL((parcelRequire("27Lyk")).resolve("lkaBR"), import.meta.url).toString();


var $47b6694004039721$exports = {};

$47b6694004039721$exports = new URL((parcelRequire("27Lyk")).resolve("3ahye"), import.meta.url).toString();


const $744d2dad838f829a$export$f9ba527e25c2bc92 = {
    lines: "lines"
};
function $744d2dad838f829a$export$adaa4cf7ef1b65be(key, data) {
    window.localStorage.setItem(key, data);
}
function $744d2dad838f829a$export$3988ae62b71be9a3(key) {
    return window.localStorage.getItem(key);
}


function $eda653b1ac4e30a6$export$3203edd9e5edd663(isoDate) {
    const date = new Date(isoDate);
    return [
        date.getHours(),
        date.getMinutes()
    ].map((t)=>String(t).padStart(2, "0")).join(":");
}
function $eda653b1ac4e30a6$export$3ae94a2503e890a1(isoDate) {
    const date = new Date(isoDate);
    const datePart = [
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate()
    ].map((t)=>String(t).padStart(2, "0")).join(".");
    return `${datePart} ${$eda653b1ac4e30a6$export$3203edd9e5edd663(isoDate)}`;
}
function $eda653b1ac4e30a6$export$1eec34638922d692(departure) {
    const timeDelta = Math.max((new Date(departure) - new Date()) / 1000, 0);
    if (timeDelta < 60) return "NOW";
    else if (timeDelta < 3600) return `${Math.floor(timeDelta / 60)}′`;
    else {
        const deltaHours = Math.floor(timeDelta / 3600);
        const deltaMinutes = Math.floor(timeDelta % 3600 / 60);
        if (deltaMinutes === 0) return `${deltaHours}h`;
        else return `${deltaHours}h ${deltaMinutes}min`;
    }
}
function $eda653b1ac4e30a6$var$img(src, alt) {
    return `<img src="${src}" alt="${alt}" />`;
}
const $eda653b1ac4e30a6$var$icons = {
    bus: $eda653b1ac4e30a6$var$img((0, (/*@__PURE__*/$parcel$interopDefault($338376e393e3617c$exports))), "Bus"),
    suburban: $eda653b1ac4e30a6$var$img((0, (/*@__PURE__*/$parcel$interopDefault($452c02b697ee67fe$exports))), "S-Bahn"),
    tram: $eda653b1ac4e30a6$var$img((0, (/*@__PURE__*/$parcel$interopDefault($b5641bcb4042e111$exports))), "Tram"),
    subway: $eda653b1ac4e30a6$var$img((0, (/*@__PURE__*/$parcel$interopDefault($9d7edfc41c7a1748$exports))), "U-Bahn"),
    regional: $eda653b1ac4e30a6$var$img((0, (/*@__PURE__*/$parcel$interopDefault($7b76604380f80eba$exports))), "Regional Train"),
    express: $eda653b1ac4e30a6$var$img((0, (/*@__PURE__*/$parcel$interopDefault($47b6694004039721$exports))), "Long Distance Train")
};
function $eda653b1ac4e30a6$export$d84916f473614728(val) {
    return $eda653b1ac4e30a6$var$icons[val] || val;
}
function $eda653b1ac4e30a6$export$d135782dcdec88fc(line) {
    const checkedLines = (0, $744d2dad838f829a$export$3988ae62b71be9a3)((0, $744d2dad838f829a$export$f9ba527e25c2bc92).lines);
    const isChecked = checkedLines.split(",").includes(line) ? "checked" : "";
    return `
    <li>
      <label>
        <input type="checkbox" id="line-${line}" data-line="${line}" name="lines" ${isChecked}/> ${line}
      </label>
    </li>
  `;
}


function $f93470cc11995b73$export$4368d992c4eafac0(s) {
    return document.querySelector(s);
}
function $f93470cc11995b73$export$f0e3bd6d422f1340() {
    const style = window.location.search.includes("blue") && "blue" || "yellow";
    $f93470cc11995b73$export$4368d992c4eafac0("html").classList.add(style);
}



async function $96e14f2a7c3555e4$export$25784826f2bbca7b(stopId) {
    const result = await fetch(`https://v6.bvg.transport.rest/stops/${stopId}/departures?results=10&pretty=false`);
    const response = await result.json();
    return {
        // show only departures with a valid when (when it's missing, it means it's cancelled?)
        departures: response.departures.filter((d)=>d.when)
    };
}
async function $96e14f2a7c3555e4$export$1a5ee2f384c71c0a(stopSearch) {
    const result = await fetch(`https://v6.bvg.transport.rest/locations?poi=false&addresses=false&query=${encodeURIComponent(stopSearch)}`);
    const json = await result.json();
    return json[0];
}
function $96e14f2a7c3555e4$export$b71bc326b9f9bec2(departures) {
    let listOfLines = [
        ...new Set(departures.map((ride)=>ride.line.productName).sort())
    ];
    if (listOfLines.length === 1) {
        (0, $f93470cc11995b73$export$4368d992c4eafac0)("#available-lines").className = "hidden";
        return departures;
    }
    const storedLines = (0, $744d2dad838f829a$export$3988ae62b71be9a3)((0, $744d2dad838f829a$export$f9ba527e25c2bc92).lines);
    if (!storedLines) (0, $744d2dad838f829a$export$adaa4cf7ef1b65be)((0, $744d2dad838f829a$export$f9ba527e25c2bc92).lines, listOfLines);
    lines.innerHTML = listOfLines.map((line)=>(0, $eda653b1ac4e30a6$export$d135782dcdec88fc)(line)).join("");
    const lineList = Array.from(document.getElementsByName("lines"));
    const selectedLines = lineList.filter((e)=>e.checked);
    const checkedLines = selectedLines.map((e)=>e.dataset.line);
    return departures.filter((ride)=>checkedLines.includes(ride.line.productName));
}


const $ef35b153f5f5a0aa$var$TMPL_REGEX = /\{([^}]+)\}/g;
function $ef35b153f5f5a0aa$export$98e6a39c04603d36(html, obj, ctx) {
    return html.trim().replace($ef35b153f5f5a0aa$var$TMPL_REGEX, (_, path)=>{
        const fnName = path.substring(0, path.indexOf("("));
        const argName = path.substring(path.indexOf("(") + 1, path.indexOf(")"));
        if (fnName && argName && ctx[fnName]) return ctx[fnName]($ef35b153f5f5a0aa$var$val(obj, argName));
        return $ef35b153f5f5a0aa$var$val(obj, path);
    });
}
function $ef35b153f5f5a0aa$var$val(obj, path) {
    if (Array.isArray(path)) {
        const firstPart = path.shift();
        if (path.length === 0) return obj[firstPart];
        return $ef35b153f5f5a0aa$var$val(obj[firstPart], path);
    }
    if (path.includes(".")) return $ef35b153f5f5a0aa$var$val(obj, path.split("."));
    return obj[path];
}





const $35da740d59af89ba$var$REFRESH_INTERVAL = 101000;
const $35da740d59af89ba$var$DEPARTURE_TMPL = `
<tr>
  <td class="line-column">{formatIcon(line.product)}{line.name}</td>
  <td class="destination-column">{destination.name}</td> 
  <td class="departure-column">{formatTime(when)}</td>
  <td class="wait-column">{formatWaitTime(when)}</td>
</tr>
`;
function $35da740d59af89ba$var$setupLineFilters() {
    const lineList = Array.from(document.getElementsByName("lines"));
    lineList.forEach((el)=>el.addEventListener("change", ()=>{
            const selectedLines = lineList.filter((e)=>e.checked);
            const checkedLines = selectedLines.map((e)=>e.dataset.line);
            (0, $744d2dad838f829a$export$adaa4cf7ef1b65be)((0, $744d2dad838f829a$export$f9ba527e25c2bc92).lines, checkedLines);
            $35da740d59af89ba$export$2cd8252107eb640b();
        }));
}
async function $35da740d59af89ba$export$2cd8252107eb640b() {
    const depTitle = (0, $f93470cc11995b73$export$4368d992c4eafac0)("#dep-title");
    const depContainer = (0, $f93470cc11995b73$export$4368d992c4eafac0)("#dep-container");
    const lastUpdated = (0, $f93470cc11995b73$export$4368d992c4eafac0)("#last-updated");
    const footer = (0, $f93470cc11995b73$export$4368d992c4eafac0)("#footer");
    const status = (0, $f93470cc11995b73$export$4368d992c4eafac0)("#status");
    const lines = (0, $f93470cc11995b73$export$4368d992c4eafac0)("#lines");
    const ctx = {
        formatTime: $eda653b1ac4e30a6$export$3203edd9e5edd663,
        formatIcon: $eda653b1ac4e30a6$export$d84916f473614728,
        formatWaitTime: $eda653b1ac4e30a6$export$1eec34638922d692
    };
    const stopSearch = document.location.hash || "Storkower";
    let timeout;
    async function refresh(stop) {
        // TODO: realtimeDataUpdatedAt sometimes goes back in time (upstream caching issue?)
        const { departures: departures, realtimeDataUpdatedAt: realtimeDataUpdatedAt } = await (0, $96e14f2a7c3555e4$export$25784826f2bbca7b)(stop.id);
        depTitle.innerText = stop.name;
        document.title = stop.name + " Departures";
        const filteredDepartures = (0, $96e14f2a7c3555e4$export$b71bc326b9f9bec2)(departures);
        $35da740d59af89ba$var$setupLineFilters();
        depContainer.innerHTML = filteredDepartures.map((dep)=>(0, $ef35b153f5f5a0aa$export$98e6a39c04603d36)($35da740d59af89ba$var$DEPARTURE_TMPL, dep, ctx)).join("");
        lastUpdated.innerText = (0, $eda653b1ac4e30a6$export$3ae94a2503e890a1)(new Date().getTime());
        footer.style.visibility = "visible";
        (0, $f93470cc11995b73$export$f0e3bd6d422f1340)();
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(()=>refresh(stop), $35da740d59af89ba$var$REFRESH_INTERVAL);
    }
    const stop = await (0, $96e14f2a7c3555e4$export$1a5ee2f384c71c0a)(stopSearch);
    if (!stop) {
        status.innerText = "Stop not found!";
        status.className = "error";
    }
    refresh(stop);
}
$35da740d59af89ba$export$2cd8252107eb640b();


//# sourceMappingURL=index.81a002e7.js.map
